import React from 'react';
import {Table} from "antd";
import {useProjectScope} from "./ProjectScopeProvider";
import ColorTag from "../../../components/ColorTag";

const DeliverableActivitiesTable = ({record, canCustomize = true, ...props}) => {

    const {
        getRecordKey,
        editScopeRecord,
        onChange,
        editingKey,
    } = useProjectScope();

    return (
        <div className="scope-inner-table px-8">
            <div className="shadow-none">
                <Table
                    rowKey="display_index"
                    dataSource={record.activities}
                    bordered
                    size="middle"
                    pagination={false}
                >
                    <Table.Column
                        title="Activities"
                        dataIndex="description"
                        width={380}
                        render={description => (
                            <div className="relative">
                                <div dangerouslySetInnerHTML={{__html: description}}
                                     className="text-xs line-clamp-3 overflow-ellipsis"/>
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Roles Used"
                        dataIndex="disciplines"
                        width={260}
                        render={disciplines => (
                            <div className="flex flex-row flex-wrap gap-3 items-center">
                                {TB.map(disciplines || [], discipline => (
                                    <ColorTag
                                        key={`rec-${record.id}-dis-${discipline.id}`}
                                        label={discipline.name}
                                        closable={false}/>
                                ))}
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Total Hours"
                        dataIndex="total_hours"
                        width={80}
                        render={total_hours => (
                            <p className={TB.mapClass("text-xs", {
                                "line-through opacity-60 text-danger": !record.is_active
                            })}>
                                {total_hours}
                            </p>
                        )}
                    />
                    <Table.Column
                        title="Est Cost"
                        dataIndex="estimated_cost"
                        width={80}
                        render={estimated_cost => (
                            <p className={TB.mapClass("text-xs", {
                                "line-through opacity-60 text-danger": !record.is_active
                            })}>
                                {TB.formatCurrency(estimated_cost)}
                            </p>
                        )}
                    />
                    <Table.Column
                        title="Actions"
                        dataIndex="operation"
                        width={100}
                        render={(_, activity) => (
                            <button className="btn btn-link btn-link-primary" disabled={!!editingKey}
                                    onClick={() => editScopeRecord(activity)}>
                                Edit
                            </button>
                        )}
                    />
                </Table>

                {canCustomize && (
                    <button className="btn btn-link btn-link-danger" disabled={!!editingKey} onClick={async (event) => {
                        let fieldName = `${getRecordKey(record)}.activities`;
                        let deliverables = [...record.activities, {
                            name: 'New Deliverable Activity',
                            is_custom: true,
                            disciplines: [],
                        }]

                        let newScope = await onChange({[fieldName]: deliverables});

                        return editScopeRecord(TB.last(TB.get(newScope, fieldName) || []))
                    }}>
                        Add new activity
                    </button>
                )}
            </div>
        </div>
    );
};

export default DeliverableActivitiesTable;